<script setup>
import {ref, watch, nextTick} from "vue";

const props = defineProps({
  // 表格信息
  tableData: {
    required: true,
    type: Array,
    default: () => []
  },
  // 已选择的门店，用于回显
  selectedStores: {
    type: Array,
    default: () => []
  },
  // 加载状态
  loading: {
    type: Boolean,
    default: false
  },
  // 商家名称
  tenantName: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['close', 'confirm'])

// 多选表格锚点
const tableRef = ref()
// 面板打开状态
const open = ref(false)
// 处理面板打开
const handleOpen = () => {
  open.value = true
}
// 处理面板关闭
const handleClose = () => {
  open.value = false
  emit('close')
}
// 处理面板确定
const handlePanelConfirm = () => {
  console.log("tempSelectedRows.value", tempSelectedRows.value)
  let resStore = tempSelectedRows.value.map(store => ({
    storeId: store.storeId,
    storeName: store.name || store.storeName,
  }))
  emit('confirm', resStore)
  handleClose()
}
// 已选择的内容
const tempSelectedRows = ref([])
// 处理选择改变
const handleSelectionChange = (rows) => {
  tempSelectedRows.value = rows
}
// 面板打开时初始化选中
watch(
    () => props.tableData,
    async (list) => {
      if (!list.length) return
      await nextTick()

      // 清空旧 selection
      tableRef.value?.clearSelection()

      // 根据父组件传来的已选项回显
      list.forEach(row => {
        if (props.selectedStores.some(s => s.storeId === row.storeId)) {
          tableRef.value?.toggleRowSelection(row, true)
        }
      })

      // 同步临时选中状态
      tempSelectedRows.value = [...props.selectedStores]
    },
    { immediate: true }
)

defineExpose({
  handleOpen,
  handleClose,
})

</script>

<template>
  <el-dialog
      v-model="open"
      width="800"
      style="padding: 20px;"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
    <template #header>
      <div style="padding: 16px 24px;font-size: 1.25rem;font-weight: 500;text-align: left;color: #000000">选择关联合作身份</div>
    </template>
    <div class="mg_b_2" style="text-align: left;padding-left: 24px;" v-if="props.tenantName">商家：{{props.tenantName}}</div>
    <el-table height="400" v-loading="props.loading" @selection-change="handleSelectionChange" row-key="storeId" ref="tableRef" :data="tableData" stripe style="width: 100%;max-height: 400px;overflow: auto;padding-left: 24px;">
      <el-table-column type="selection" width="55"/>
      <el-table-column prop="storeType" label="合作身份类型">
        <template #default="scope">
          <span v-if="scope.row.storeType === 'STATION'">驿站</span>
          <span v-else-if="scope.row.storeType === 'ONLINE_STORE'">网店</span>
          <span v-else-if="scope.row.storeType === 'CLUB'">俱乐部</span>
          <span v-else-if="scope.row.storeType === 'TENNIS_VENUE'">网球场馆</span>
          <span v-else-if="scope.row.storeType === 'PUMP_TRACK_VENUE'">泵道场地</span>
          <span v-else-if="scope.row.storeType === 'MOUNTAIN_BIKE_VENUE'">山地车场地</span>
          <span v-else-if="scope.row.storeType === 'BMX_VENUE'">小轮车场地</span>
          <span v-else-if="scope.row.storeType === 'BIKE_STORE'">单车4S店</span>
          <span v-else-if="scope.row.storeType === 'THERAPIST_STORE'">理疗师店</span>
          <span v-else-if="scope.row.storeType === 'PHOTOGRAPHY_STORE'">摄影师店</span>
        </template>
      </el-table-column>
      <el-table-column prop="name" label="合作身份名称" />
    </el-table>

    <template #footer>
      <div class="dialog-footer">
        <v-row>
          <v-col cols="5" offset="7">
            <div class="flex_right">
              <v-btn variant="elevated" @click="handleClose">取消</v-btn>
              <v-btn :disabled="loading || props.tableData.length <= 0" class="mg_l_1" color="primary" variant="elevated" @click="handlePanelConfirm">确定</v-btn>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </el-dialog>
</template>

<style scoped>

</style>
